import { c as _c } from "react/compiler-runtime";
import { TableHeader, TableHeaderCell } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { TABLE_ROW_CLASS_NAMES } from "./utils";
export function ItemPreviewTooltipTraitTableHeader() {
  const $ = _c(16);
  const t = useTranslations("ItemPreviewTooltipTraitTableHeader");
  let t0;
  if ($[0] !== t) {
    t0 = t("attribute");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TableHeaderCell>{t0}</TableHeaderCell>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("trait");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <TableHeaderCell>{t2}</TableHeaderCell>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("floor");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <TableHeaderCell>{t4}</TableHeaderCell>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t3 || $[14] !== t5) {
    t6 = <TableHeader className={TABLE_ROW_CLASS_NAMES}>{t1}{t3}{t5}</TableHeader>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}